/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const vehicleFuelUsedJSON = async (): Promise<any> => {
  const vehicleFuelUsed = useJSONStore.getState().vehicleFuelUsed;
  const token = useUserStore.getState().userToken;
  const setVehicleFuelUsed = useJSONStore.getState().setVehicleFuelUsed;

  if (vehicleFuelUsed.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.vehicleFuelUsed}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setVehicleFuelUsed(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default vehicleFuelUsedJSON;
